export default defineNuxtRouteMiddleware((to) => {
	const { $messages } = useNuxtApp()
	const settingsStore = useSettingsStore()

	// @ts-ignore
	if (!$messages.$loaded()) {
		return
	}

	if (to.path === "/orders") {
		// @ts-ignore
		settingsStore.setCurrentPageTitle($messages.$t("myOrders"))
	} else if (to.path === "/items") {
		// @ts-ignore
		settingsStore.setCurrentPageTitle($messages.$t("myItems"))
	} else if (to.path === "/myAccount") {
		// @ts-ignore
		settingsStore.setCurrentPageTitle($messages.$t("myAccount"))
	} else if (to.path === "/myQrCode") {
		// @ts-ignore
		settingsStore.setCurrentPageTitle($messages.$t("myQrCode"))
	} else {
		settingsStore.clearCurrentPageTitle()
	}
})
